import { createSelector } from 'reselect';

const selectCourse = (state) => state.skillQuestsMasteryStudent.selectedCourse;
const selectIsFiltered = (state) => state.skillQuestsMasteryStudent.isFiltered;

const selectCourseData = createSelector(
    [selectCourse, selectIsFiltered],
    (selectedCourse, isFiltered) => {
        let courseId = null;
        let courseVersion = null;

        if (isFiltered) {
            courseId = selectedCourse.selected.id;
            courseVersion = selectedCourse.selected.version;
        }

        return {
            courseId,
            courseVersion
        };
    }
);

export default {
    selectCourseData
};



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/student-selectors.js